
export const HEAD_ROW_HEIGHT_PX = 52;
export const BODY_ROW_HEIGHT_PX = 64;
